import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { inventarioService } from '../../services/api';
import { chip } from '../../components/ui/estilos';
import { entrada } from '../agenda/campos';
import { TIPO_MOV, cant, fechaCorta, num } from './insumos';

// '' = todos. El tipo se filtra en el servidor para que el límite de 300 no esconda los raros.
const FILTROS: [string, string][] = [['', 'Todos'], ['entrada', 'Entradas'], ['ajuste', 'Salidas'], ['merma', 'Mermas'], ['venta', 'Ventas'], ['requisicion', 'Requisiciones'], ['consumo_empleado', 'Comida empleados']];
const COLOR: Record<string, [string, string]> = {
  entrada: ['var(--ok-bg)', 'var(--ok)'], merma: ['var(--danger-bg)', 'var(--danger)'], venta: ['var(--info-bg)', 'var(--info)'],
};
const fila: React.CSSProperties = { display: 'grid', gridTemplateColumns: '120px minmax(0,1fr) minmax(0,1.3fr) 130px 110px', gap: 10, alignItems: 'center', padding: '12px 16px', fontSize: 15, minWidth: 640 };

export default function Movimientos() {
  const [tipo, setTipo] = useState('');
  const [busca, setBusca] = useState('');
  const [movs, setMovs] = useState<any[] | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    setMovs(null); setError(false);
    inventarioService.getMovimientosTodos(tipo).then(r => setMovs(r.data)).catch(() => setError(true));
  }, [tipo]);

  const q = busca.trim().toLowerCase();
  const visibles = (movs || []).filter(m => !q || m.insumo.toLowerCase().includes(q) || (m.motivo || '').toLowerCase().includes(q) || (m.usuario || '').toLowerCase().includes(q));

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        <Link to="/inventario" style={{ fontSize: 14, fontWeight: 700, color: 'var(--muted)', textDecoration: 'none' }}>← Inventario</Link>
        <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700 }}>Movimientos</h1>
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
        <input value={busca} onChange={e => setBusca(e.target.value)} placeholder="Buscar por insumo, motivo o persona…" aria-label="Buscar movimiento" style={{ ...entrada, flex: 1, minWidth: 220, width: 'auto', borderRadius: 12 }} />
      </div>
      <div role="group" aria-label="Tipo de movimiento" style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
        {FILTROS.map(([k, l]) => (
          <button key={k} onClick={() => setTipo(k)} aria-pressed={tipo === k} style={{ height: 40, padding: '0 14px', borderRadius: 999, fontSize: 14, fontWeight: 700, cursor: 'pointer',
            border: `1px solid ${tipo === k ? 'var(--ink)' : 'var(--line-strong)'}`, background: tipo === k ? 'var(--ink)' : 'var(--surface)', color: tipo === k ? 'var(--bg)' : 'var(--ink)' }}>{l}</button>
        ))}
      </div>
      <div role="table" aria-label="Movimientos" style={{ borderRadius: 14, border: '1px solid var(--line)', background: 'var(--surface)', overflowX: 'auto' }}>
        <div role="row" style={{ ...fila, fontSize: 12, fontWeight: 700, color: 'var(--muted)', background: 'var(--well)' }}>
          <span>FECHA</span><span>INSUMO</span><span>MOTIVO</span><span>TIPO</span><span style={{ textAlign: 'right' }}>CANTIDAD</span>
        </div>
        {error && <div role="alert" style={{ padding: 30, textAlign: 'center', color: 'var(--danger)' }}>No se pudieron cargar los movimientos.</div>}
        {!movs && !error && <div style={{ padding: 30, textAlign: 'center', color: 'var(--muted)' }}>Cargando…</div>}
        {movs && !visibles.length && <div style={{ padding: 30, textAlign: 'center', color: 'var(--muted)' }}>No hay movimientos con ese filtro.</div>}
        {visibles.map(m => {
          const c = num(m.cantidad);
          const [bg, fg] = COLOR[m.tipo] || ['var(--well)', 'var(--ink)'];
          return (
            <div key={m.id} role="row" style={{ ...fila, borderTop: '1px solid var(--line)' }}>
              <span style={{ fontSize: 14, color: 'var(--muted)' }}>{fechaCorta(m.created_at)}</span>
              <b style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{m.insumo}</b>
              <span style={{ minWidth: 0 }}>
                <span style={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{m.motivo || '—'}</span>
                <span style={{ fontSize: 12, color: 'var(--muted)' }}>{m.usuario}</span>
              </span>
              <span><span style={{ ...chip(bg, fg), fontSize: 13 }}>{TIPO_MOV[m.tipo] || m.tipo}</span></span>
              <span style={{ textAlign: 'right', fontWeight: 700, color: c >= 0 ? 'var(--ok)' : 'var(--danger)', whiteSpace: 'nowrap' }}>{c >= 0 ? '+' : '−'}{cant(Math.abs(c))} {m.unidad}</span>
            </div>
          );
        })}
      </div>
      {movs && movs.length >= 300 && <div style={{ fontSize: 14, color: 'var(--muted)' }}>Se muestran los 300 más recientes. Filtra por tipo para ver más atrás.</div>}
    </div>
  );
}
